/**
 * Outline SVG icon module.
 */
import * as React from "react";
/**
 * Chevron Up (outline) SVG icon. Generated wrapper that forwards props to the root svg.
 *
 * @param {React.SVGProps<SVGSVGElement>} props SVG element props.
 * @returns {JSX.Element}
 */
const SvgChevronUp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m35 45 7-7 7 7"
    />
  </svg>
);
export default SvgChevronUp;
